<template>
    <div>
        <div class="sfz" v-if="type!=='other'">
            <van-uploader v-if="type !== 'person' && type !== 'book'" :after-read="upload" result-type="file" :disabled="isProcessing">
                <div v-if="!url && !pendingPreview">
                    <div class="sfz-image">
                        <img src="@/static/image/index/5.png">
                    </div>
                    <div class="sfz-button">
                        <div class="sfz-icon">
                            <img src="@/static/image/index/3.png">
                        </div>
                        <div class="sfz-text">{{name}}</div>
                    </div>
                </div>
                <div class="cert" v-else>
                    <img :src="url || pendingPreview">
                    <span class="replace-label">重新上传</span>
                </div>
            </van-uploader>

            <button v-else-if="type === 'book'" type="button" class="person-upload" :disabled="isProcessing" @click="openBookOptions">
                <div v-if="!url && !pendingPreview">
                    <div class="sfz-image">
                        <img src="@/static/image/index/5.png">
                    </div>
                    <div class="sfz-button">
                        <div class="sfz-icon">
                            <img src="@/static/image/index/3.png">
                        </div>
                        <div class="sfz-text">{{name}}</div>
                    </div>
                </div>
                <div class="cert" v-else>
                    <img :src="url || pendingPreview">
                    <span class="replace-label">重新上传</span>
                </div>
            </button>

            <button v-else type="button" class="person-upload" :disabled="isProcessing" @click="openGuidedCamera">
                <div v-if="!url && !pendingPreview">
                    <div class="sfz-image">
                        <img src="@/static/image/index/5.png">
                    </div>
                    <div class="sfz-button">
                        <div class="sfz-icon">
                            <img src="@/static/image/index/3.png">
                        </div>
                        <div class="sfz-text">{{name}}</div>
                    </div>
                </div>
                <div class="cert" v-else>
                    <img :src="url || pendingPreview">
                    <span class="replace-label">重新拍摄</span>
                </div>
            </button>

            <div v-if="isProcessing" class="upload-progress">正在压缩并上传图片…</div>
            <div v-else-if="pendingMessage" class="upload-progress upload-error">{{ pendingMessage }}</div>
        </div>

        <van-action-sheet
            v-model="bookOptionsVisible"
            :actions="bookActions"
            cancel-text="取消"
            close-on-click-action
            @select="selectBookSource"
        ></van-action-sheet>
        <input ref="bookCamera" class="hidden-picker" type="file" accept="image/*" capture="environment" @change="selectBookFile">
        <input ref="bookGallery" class="hidden-picker" type="file" accept="image/*" @change="selectBookFile">

        <guided-face-camera ref="guidedCamera" @capture="capturePersonalPhoto" @select="selectPersonalPhoto"></guided-face-camera>

        <div class="other" v-if="type=='other'">
            <div class="other-name">请上传{{cate.other_name}}</div>
            <div class="other-image">
                <upload-image @callback="uploadOther" :max="cate.max_other" :list="[]"></upload-image>
            </div>
            <div class="other-desc">
                {{cate.other_demand}}
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters, mapMutations } from 'vuex';
    import { Toast } from 'vant';
    import { card_sfz, card_book } from '@/api/card.js';
    import { common_image } from '@/api/common.js';
    import GuidedFaceCamera from '@/components/GuidedFaceCamera.vue';
    import { compressUploadImage, formatFileSize } from '@/utils/imageCompression';
    import { checkPhotoFace, getFaceStatus } from '@/utils/faceDetection';
    export default {
        name: "index",
        data() {
            return {
                form: {},
                isProcessing: false,
                pendingFile: null,
                pendingPreview: '',
                pendingMessage: '',
                bookOptionsVisible: false,
                bookActions: [
                    { name: '拍摄户口本', source: 'camera' },
                    { name: '从相册选择', source: 'gallery' },
                ],
            }
        },
        components: { GuidedFaceCamera },
        props: {
            type: {
                type: String,
                default: '',
            },
            name: {
                type: String,
                default: '',
            },
            capture: {
                type: String,
                default: '',
            },
        },
        watch: {
            card(value) {
                if (value) {
                    this.form = value;
                }
            },
            form(value) {
                if (value) {
                    this.setCard(this.form);
                }
            }
        },
        created() {
            this.form = this.card;
        },
        beforeDestroy() {
            this.clearPending();
        },
        computed: {
            ...mapGetters(['card']),
            cate() {
                return this.card.cate;
            },
            url() {
                if (this.form.cert_type == 1) {
                    return this.form.photo_sfz_1;
                }
                if (this.form.cert_type == 2) {
                    if(this.type=='book'){
                        return this.form.photo_book;
                    }
                    if(this.type=='person'){
                        return this.form.photo_person;
                    }
                }
                return '';
            },
        },
        methods: {
            ...mapMutations(['setCard']),
            upload(file) {
                this.processFile(file.file || file, false);
            },
            openGuidedCamera() {
                this.pendingMessage = '';
                this.$refs.guidedCamera.open();
            },
            openBookOptions() {
                this.pendingMessage = '';
                this.bookOptionsVisible = true;
            },
            selectBookSource(action) {
                if (action.source === 'camera') {
                    this.$refs.bookCamera.click();
                    return;
                }
                this.$refs.bookGallery.click();
            },
            selectBookFile(event) {
                const file = event.target.files && event.target.files[0];
                event.target.value = '';
                if (file) {
                    this.processFile(file, false);
                }
            },
            capturePersonalPhoto(file) {
                this.processFile(file, true);
            },
            selectPersonalPhoto(file) {
                this.processFile(file, true);
            },
            setPending(file) {
                this.clearPending();
                this.pendingFile = file;
                this.pendingPreview = URL.createObjectURL(file);
            },
            clearPending() {
                if (this.pendingPreview) {
                    URL.revokeObjectURL(this.pendingPreview);
                }
                this.pendingFile = null;
                this.pendingPreview = '';
                this.pendingMessage = '';
            },
            async processFile(sourceFile, requiresFace) {
                if (!sourceFile || !sourceFile.type || !sourceFile.type.startsWith('image/')) {
                    Toast('请选择图片文件');
                    return;
                }

                this.setPending(sourceFile);
                this.isProcessing = true;
                var form = new FormData();
                form.set("cate_id", this.cate.id);
                form.set("company_id", this.$route.query.id);

                Toast.loading({
                    duration: 0,
                    forbidClick: true,
                    message: '正在压缩图片…',
                });

                try {
                    const processedFile = await compressUploadImage(sourceFile, this.type, (progress) => {
                        if (progress >= 100) {
                            Toast.loading({ duration: 0, forbidClick: true, message: '正在检查图片…' });
                        }
                    });
                    this.pendingFile = processedFile;

                    if (requiresFace) {
                        try {
                            const faceState = await checkPhotoFace(processedFile);
                            if (faceState !== 'ready') {
                                this.pendingMessage = getFaceStatus(faceState).message;
                                Toast(`${this.pendingMessage}，已继续上传`);
                            }
                        } catch (error) {
                            Toast('人脸识别暂不可用，已继续上传');
                        }
                    }

                    form.set("file", processedFile);
                    Toast.loading({ duration: 0, forbidClick: true, message: `上传中（${formatFileSize(processedFile.size)}）…` });
                    const response = await this.uploadToServer(form);
                    if (!response || response.code != 1) {
                        throw new Error((response && (response.msg || response.message)) || '上传失败，请重试');
                    }
                    Toast.clear();
                    this.callback(response);
                    this.clearPending();
                } catch (error) {
                    this.pendingMessage = error.message || '图片上传失败，请点击图片重试';
                    Toast.clear();
                    Toast.fail(this.pendingMessage);
                } finally {
                    this.isProcessing = false;
                }
            },
            uploadToServer(form) {
                if (this.type == 'sfz') {
                    return card_sfz(form);
                }
                if (this.type == 'book') {
                    return card_book(form);
                }
                return common_image(form);
            },

            callback(res) {
                Toast.clear();
                if (this.type == 'person') {
                    Toast('上传成功');
                    this.$set(this.form, 'photo_person', res.data);
                } else {
                    Toast('识别成功');
                    if (this.type == 'sfz') {
                        this.$set(this.form, 'photo_sfz_1', res.data.url);
                        this.$set(this.form, 'ocr_sfz', res.data.ocr_info);
                    }
                    if (this.type == 'book') {
                        this.$set(this.form, 'photo_book', res.data.url);
                        this.$set(this.form, 'ocr_book', res.data.ocr_info);
                    }
                    this.$set(this.form, 'is_handle', res.data.is_handle);
                    this.$set(this.form, 'name', res.data.ocr_info.name);
                    this.$set(this.form, 'sfz', res.data.ocr_info.idCardNo);
                }
                this.setCard(this.form);
            },

            //上传其他资料
            uploadOther(e) {
                this.other = e;
                this.$set(this.form, 'photo_other', this.other);
            },
        }
    }
</script>

<style scoped>
    .upload {
        margin-top: 20px;
        margin-left: 20px;
        width: calc(100% - 40px);
    }

    .sfz {
        margin-left: 20px;
        width: calc(100% - 40px);
        margin-top: 20px;
        background: #F2F2F2;
        position: relative;
    }

    .person-upload {
        background: transparent;
        border: 0;
        display: block;
        padding: 0;
        position: relative;
        text-align: left;
        width: 100%;
    }

    .person-upload:disabled {
        opacity: 0.7;
    }

    .hidden-picker {
        display: none;
    }

    .sfz-image {
        padding: 20px 50px;
    }

    .sfz-image img {
        width: 100%;
    }

    .sfz-button {
        position: absolute;
        top: 72px;
        left: calc(50% - 85px);
        text-align: center;
        background-color: var(--main-color);
        width: 170px;
        height: 40px;
        border-radius: 20px;
    }

    .sfz-icon {
        position: absolute;
        left: 20px;
        top: 10px;
    }

    .sfz-icon img {
        height: 20px;
    }

    .sfz-text {
        width: 140px;
        position: absolute;
        left: 20px;
        line-height: 40px;
        font-family: 'FZCS';
        color: #fff;
        font-size: 20px;
    }

    .cert {
        overflow: hidden;
    }

    .cert img {
        width: 100%;
    }

    .replace-label,
    .upload-progress {
        background: rgba(6, 9, 32, 0.72);
        bottom: 10px;
        color: #fff;
        font-size: 13px;
        left: 50%;
        padding: 6px 10px;
        position: absolute;
        transform: translateX(-50%);
        white-space: nowrap;
    }

    .replace-label {
        bottom: 12px;
    }

    .upload-progress {
        bottom: 14px;
        z-index: 3;
    }

    .upload-error {
        background: #af5c26;
    }

    .other {
        margin-left: 20px;
        width: calc(100% - 40px);
        margin-top: 30px;
    }

    .other-name {
        font-family: 'FZCS';
        font-size: 16px;
    }

    .other-image {
        margin-top: 10px;
    }

    .other-desc {
        background: #EAF9F5;
        border-radius: 6px;
        padding: 15px;
        font-size: 14px;
        color: #060920;
        margin-top: 16px;
    }
</style>
